@if (alert) {
  <div>
    <div class="clearfix">
      @if (alert.notes && alert.notes.length > 0) {
        <div class="float-left ml-2 mt-2">
          <strong><span class="fa-light fa-fw fa-copy"></span>&nbsp;&nbsp;{{'NOTES' |translate}}
        ({{alert.notes.length}})</strong>
      </div>
    }
    @if (alert.notes && alert.notes.length > 1) {
      <div class="float-left ml-2 mt-2">
        @if (noteShowCount === 1) {
          <span class="alertCardClickTarget"
          (click)="noteShowCount = alert.notes.length">{{'SHOW_ALL' |translate}}</span>
        }
        @if (noteShowCount > 1) {
          <span class="alertCardClickTarget" (click)="noteShowCount = 1">{{'SHOW_NEWEST'
          |translate}}</span>
        }
      </div>
    }
  </div>
  @if (alert.notes && alert.notes.length > 0) {
    <div class="mt-2 ml-5 clearfix">
      @for (note of alert.notes |slice:0:noteShowCount; track note) {
        <div>
          <small>{{note.writtenBy}} - {{note.time |moment: 'l LTS'}}</small>
          <p>{{note.text}}</p>
        </div>
      }
    </div>
  }
</div>
}
